import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	checkIconLabel: {
		id: 'company-hub.color-picker.pressable-color-tile.check-icon-label',
		description:
			'Accessible label of the presable / button-like color tile when the user has selected the color of this tile among the many available',
		defaultMessage: 'Selected',
	},
});
